<template>
  <Modal v-model="modal" title="选择联系人" width="50">
    <Button type="success" style="margin-left:16px" @click="onAddLinkMan">新增联系人</Button>
    <Table v-if="tableShow" :columns="columns" :data="contactList" border stripe size="small" highlight-row style="margin: 20px" @on-current-change="currentRow => selectedContact = currentRow">
      <template #action="{ row, index }">
        <Button size="small" type="primary">调度</Button>
      </template>
    </Table>
    <template #footer>
      <Button type="primary" @click="selectContact">确定</Button>
    </template>
    <Modal v-model="addLinkMan" title="新增联系人" @on-cancel="cancel">
      <Form ref="memberContact" label-position="right" :model="memberContact" :label-width="80" inline :rules="ruleValidate">
        <FormItem label="联系人" prop="name">
          <Input v-model="memberContact.name" placeholder="请输入" style="width:200px" />
        </FormItem>
        <FormItem label="电话号码" prop="mobile">
          <Input v-model="memberContact.mobile" placeholder="请输入" style="width:200px" />
        </FormItem>
        <FormItem label="邮箱">
          <Input v-model="memberContact.email" placeholder="请输入" style="width:200px" />
        </FormItem>
        <FormItem label="证件号码">
          <Input v-model="memberContact.identityNo" placeholder="请输入" style="width:200px" />
        </FormItem>
      </Form>
      <template #footer>
        <Button type="primary" @click="addNewContact">提交</Button>
      </template>
    </Modal>
  </Modal>
</template>

<script>
import { phoneTel, emailRegx } from "@/libs/constant/regx-const.js";
export default {
  data() {
    return {
      modal: false,
      addLinkMan: false,
      tableShow: false,
      contactList: [],
      columns: [
        { key: "id", title: "联系人ID" },
        { key: "name", title: "姓名" },
        { key: "mobile", title: "手机号" },
        { key: "email", title: "邮箱" },
        { key: "identityNo", title: "证件号" },
      ],
      memberContact: {
        memberId: "",
        name: "",
        mobile: "",
        email: "",
        identityNo: "",
      },
      selectedContact: {},
      ruleValidate: {
        name: [{ required: true, message: "联系人不能为空" }],
        mobile: [
          { required: true, message: "电话号码不能为空" },
          { pattern: phoneTel, message: "请输入电话号码" }
        ],
        // email: [{ required: true, message: "邮箱不能为空" },
        // { pattern: emailRegx, message: '请输入正确邮箱', }]
      },
    };
  },
  watch: {},
  methods: {
    openModal(memberId) {
      this.initContact(memberId);
      this.memberContact.memberId = memberId;
      this.modal = true;
    },
    initContact(memberId) {
      if (!memberId) return this.$Notice.error({ title: "请给定客户ID" });

      let param = {
        url: "http://CORE-MEMBER/messageService/contactService/queryContactListByMemberId",
        body: { memberId, excludeDisabled: true },
      };
      this.tableShow = false;
      this.invoke(param).then((rs) => {
        this.tableShow = true;
        this.contactList = rs;
      });
    },
    selectContact() {
      if (!this.selectedContact.id)
        return this.$Notice.error({ title: "请选择联系人" });
      this.$emit("on-select-contact", this.selectedContact);
      this.modal = false;
    },
    onAddLinkMan() {
      this.addLinkMan = true;
    },
    addNewContact() {
      let params = {
        url: "http://CORE-MEMBER/messageService/contactService/addMemberContract",
        body: { memberContact: this.memberContact },
      };
      this.$refs["memberContact"].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: "确定要新增联系人吗?",
            onOk: () => {
              this.invoke(params).then((rs) => {
                this.$Message.success("操作成功!");
                this.addLinkMan = false;
                this.cancel();
                this.initContact(this.memberContact.memberId);
              });
            },
          });
        }
      });
    },
    cancel() {
      this.$refs["memberContact"].resetFields();
      (this.memberContact.identityNo = ""), (this.memberContact.email = "");
    },
  },
};
</script>